"use strict";

var _toConsumableArray = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/toConsumableArray");

var _slicedToArray = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/slicedToArray");

var _classCallCheck = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EventListeners = void 0;

var Enums_1 = require("../Enums");

var Constants_1 = require("./Constants");

var Utils_1 = require("./Utils");

function manageListener(element, event, handler, add, options) {
  if (add) {
    var addOptions = {
      passive: true
    };

    if (typeof options === "boolean") {
      addOptions.capture = options;
    } else if (options !== undefined) {
      addOptions = options;
    }

    element.addEventListener(event, handler, addOptions);
  } else {
    var removeOptions = options;
    element.removeEventListener(event, handler, removeOptions);
  }
}

var EventListeners =
/*#__PURE__*/
function () {
  function EventListeners(container) {
    var _this = this;

    _classCallCheck(this, EventListeners);

    this.container = container;
    this.canPush = true;

    this.mouseMoveHandler = function (e) {
      return _this.mouseTouchMove(e);
    };

    this.touchStartHandler = function (e) {
      return _this.mouseTouchMove(e);
    };

    this.touchMoveHandler = function (e) {
      return _this.mouseTouchMove(e);
    };

    this.touchEndHandler = function () {
      return _this.mouseTouchFinish();
    };

    this.mouseLeaveHandler = function () {
      return _this.mouseTouchFinish();
    };

    this.touchCancelHandler = function () {
      return _this.mouseTouchFinish();
    };

    this.touchEndClickHandler = function (e) {
      return _this.mouseTouchClick(e);
    };

    this.mouseUpHandler = function (e) {
      return _this.mouseTouchClick(e);
    };

    this.mouseDownHandler = function () {
      return _this.mouseDown();
    };

    this.visibilityChangeHandler = function () {
      return _this.handleVisibilityChange();
    };

    this.themeChangeHandler = function (e) {
      return _this.handleThemeChange(e);
    };

    this.resizeHandler = function () {
      return _this.handleWindowResize();
    };
  }

  _createClass(EventListeners, [{
    key: "addListeners",
    value: function addListeners() {
      this.manageListeners(true);
    }
  }, {
    key: "removeListeners",
    value: function removeListeners() {
      this.manageListeners(false);
    }
  }, {
    key: "manageListeners",
    value: function manageListeners(add) {
      var _this2 = this;

      var _a;

      var container = this.container;
      var options = container.actualOptions;
      var detectType = options.interactivity.detectsOn;
      var mouseLeaveEvent = Constants_1.Constants.mouseLeaveEvent;

      if (detectType === Enums_1.InteractivityDetect.window) {
        container.interactivity.element = window;
        mouseLeaveEvent = Constants_1.Constants.mouseOutEvent;
      } else if (detectType === Enums_1.InteractivityDetect.parent && container.canvas.element) {
        var canvasEl = container.canvas.element;
        container.interactivity.element = (_a = canvasEl.parentElement) !== null && _a !== void 0 ? _a : canvasEl.parentNode;
      } else {
        container.interactivity.element = container.canvas.element;
      }

      var mediaMatch = typeof matchMedia !== "undefined" && matchMedia("(prefers-color-scheme: dark)");

      if (mediaMatch) {
        manageListener(mediaMatch, "change", this.themeChangeHandler, add);
      }

      var interactivityEl = container.interactivity.element;

      if (!interactivityEl) {
        return;
      }

      var html = interactivityEl;

      if (options.interactivity.events.onHover.enable || options.interactivity.events.onClick.enable) {
        manageListener(interactivityEl, Constants_1.Constants.mouseMoveEvent, this.mouseMoveHandler, add);
        manageListener(interactivityEl, Constants_1.Constants.touchStartEvent, this.touchStartHandler, add);
        manageListener(interactivityEl, Constants_1.Constants.touchMoveEvent, this.touchMoveHandler, add);

        if (!options.interactivity.events.onClick.enable) {
          manageListener(interactivityEl, Constants_1.Constants.touchEndEvent, this.touchEndHandler, add);
        } else {
          manageListener(interactivityEl, Constants_1.Constants.touchEndEvent, this.touchEndClickHandler, add);
          manageListener(interactivityEl, Constants_1.Constants.mouseUpEvent, this.mouseUpHandler, add);
          manageListener(interactivityEl, Constants_1.Constants.mouseDownEvent, this.mouseDownHandler, add);
        }

        manageListener(interactivityEl, mouseLeaveEvent, this.mouseLeaveHandler, add);
        manageListener(interactivityEl, Constants_1.Constants.touchCancelEvent, this.touchCancelHandler, add);
      }

      if (container.canvas.element) {
        container.canvas.element.style.pointerEvents = html === container.canvas.element ? "initial" : "none";
      }

      if (options.interactivity.events.resize) {
        if (typeof ResizeObserver !== "undefined") {
          if (this.resizeObserver && !add) {
            if (container.canvas.element) {
              this.resizeObserver.unobserve(container.canvas.element);
            }

            this.resizeObserver.disconnect();
            delete this.resizeObserver;
          } else if (!this.resizeObserver && add && container.canvas.element) {
            this.resizeObserver = new ResizeObserver(function (entries) {
              var entry = entries.find(function (e) {
                return e.target === container.canvas.element;
              });

              if (!entry) {
                return;
              }

              _this2.handleWindowResize();
            });
            this.resizeObserver.observe(container.canvas.element);
          }
        } else {
          manageListener(window, Constants_1.Constants.resizeEvent, this.resizeHandler, add);
        }
      }

      if (document) {
        manageListener(document, Constants_1.Constants.visibilityChangeEvent, this.visibilityChangeHandler, add, false);
      }
    }
  }, {
    key: "handleWindowResize",
    value: function handleWindowResize() {
      var _this3 = this;

      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
        delete this.resizeTimeout;
      }

      this.resizeTimeout = setTimeout(function () {
        var _a;

        return (_a = _this3.container.canvas) === null || _a === void 0 ? void 0 : _a.windowResize();
      }, 500);
    }
  }, {
    key: "handleVisibilityChange",
    value: function handleVisibilityChange() {
      var container = this.container;
      var options = container.actualOptions;
      this.mouseTouchFinish();

      if (!options.pauseOnBlur) {
        return;
      }

      if (document === null || document === void 0 ? void 0 : document.hidden) {
        container.pageHidden = true;
        container.pause();
      } else {
        container.pageHidden = false;

        if (container.getAnimationStatus()) {
          container.play(true);
        } else {
          container.draw(true);
        }
      }
    }
  }, {
    key: "mouseDown",
    value: function mouseDown() {
      var interactivity = this.container.interactivity;

      if (interactivity) {
        var mouse = interactivity.mouse;
        mouse.clicking = true;
        mouse.downPosition = mouse.position;
      }
    }
  }, {
    key: "mouseTouchMove",
    value: function mouseTouchMove(e) {
      var _a, _b, _c, _d, _e, _f, _g;

      var container = this.container;
      var options = container.actualOptions;

      if (((_a = container.interactivity) === null || _a === void 0 ? void 0 : _a.element) === undefined) {
        return;
      }

      container.interactivity.mouse.inside = true;
      var pos;
      var canvas = container.canvas.element;

      if (e.type.startsWith("mouse")) {
        this.canPush = true;
        var mouseEvent = e;

        if (container.interactivity.element === window) {
          if (canvas) {
            var clientRect = canvas.getBoundingClientRect();
            pos = {
              x: mouseEvent.clientX - clientRect.left,
              y: mouseEvent.clientY - clientRect.top
            };
          }
        } else if (options.interactivity.detectsOn === Enums_1.InteractivityDetect.parent) {
          var source = mouseEvent.target;
          var target = mouseEvent.currentTarget;
          var canvasEl = container.canvas.element;

          if (source && target && canvasEl) {
            var sourceRect = source.getBoundingClientRect();
            var targetRect = target.getBoundingClientRect();
            var canvasRect = canvasEl.getBoundingClientRect();
            pos = {
              x: mouseEvent.offsetX + 2 * sourceRect.left - (targetRect.left + canvasRect.left),
              y: mouseEvent.offsetY + 2 * sourceRect.top - (targetRect.top + canvasRect.top)
            };
          } else {
            pos = {
              x: (_b = mouseEvent.offsetX) !== null && _b !== void 0 ? _b : mouseEvent.clientX,
              y: (_c = mouseEvent.offsetY) !== null && _c !== void 0 ? _c : mouseEvent.clientY
            };
          }
        } else {
          if (mouseEvent.target === container.canvas.element) {
            pos = {
              x: (_d = mouseEvent.offsetX) !== null && _d !== void 0 ? _d : mouseEvent.clientX,
              y: (_e = mouseEvent.offsetY) !== null && _e !== void 0 ? _e : mouseEvent.clientY
            };
          }
        }
      } else {
        this.canPush = e.type !== "touchmove";
        var touchEvent = e;
        var lastTouch = touchEvent.touches[touchEvent.touches.length - 1];

        var _canvasRect = canvas === null || canvas === void 0 ? void 0 : canvas.getBoundingClientRect();

        pos = {
          x: lastTouch.clientX - ((_f = _canvasRect === null || _canvasRect === void 0 ? void 0 : _canvasRect.left) !== null && _f !== void 0 ? _f : 0),
          y: lastTouch.clientY - ((_g = _canvasRect === null || _canvasRect === void 0 ? void 0 : _canvasRect.top) !== null && _g !== void 0 ? _g : 0)
        };
      }

      var pxRatio = container.retina.pixelRatio;

      if (pos) {
        pos.x *= pxRatio;
        pos.y *= pxRatio;
      }

      container.interactivity.mouse.position = pos;
      container.interactivity.status = Constants_1.Constants.mouseMoveEvent;
    }
  }, {
    key: "mouseTouchFinish",
    value: function mouseTouchFinish() {
      var interactivity = this.container.interactivity;

      if (interactivity === undefined) {
        return;
      }

      var mouse = interactivity.mouse;
      delete mouse.position;
      delete mouse.clickPosition;
      delete mouse.downPosition;
      interactivity.status = Constants_1.Constants.mouseLeaveEvent;
      mouse.inside = false;
      mouse.clicking = false;
    }
  }, {
    key: "mouseTouchClick",
    value: function mouseTouchClick(e) {
      var container = this.container;
      var options = container.actualOptions;
      var mouse = container.interactivity.mouse;
      mouse.inside = true;
      var handled = false;
      var mousePosition = mouse.position;

      if (mousePosition === undefined || !options.interactivity.events.onClick.enable) {
        return;
      }

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = container.plugins[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _step$value = _slicedToArray(_step.value, 2),
              plugin = _step$value[1];

          if (plugin.clickPositionValid !== undefined) {
            handled = plugin.clickPositionValid(mousePosition);

            if (handled) {
              break;
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (!handled) {
        this.doMouseTouchClick(e);
      }

      mouse.clicking = false;
    }
  }, {
    key: "doMouseTouchClick",
    value: function doMouseTouchClick(e) {
      var _this4 = this;

      var container = this.container;
      var options = container.actualOptions;

      if (this.canPush) {
        var mousePos = container.interactivity.mouse.position;

        if (mousePos) {
          container.interactivity.mouse.clickPosition = {
            x: mousePos.x,
            y: mousePos.y
          };
        } else {
          return;
        }

        container.interactivity.mouse.clickTime = new Date().getTime();
        var onClick = options.interactivity.events.onClick;

        if (onClick.mode instanceof Array) {
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = onClick.mode[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var mode = _step2.value;
              this.handleClickMode(mode);
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        } else {
          this.handleClickMode(onClick.mode);
        }
      }

      if (e.type === "touchend") {
        setTimeout(function () {
          return _this4.mouseTouchFinish();
        }, 500);
      }
    }
  }, {
    key: "handleThemeChange",
    value: function handleThemeChange(e) {
      var mediaEvent = e;
      var themeName = mediaEvent.matches ? this.container.options.defaultDarkTheme : this.container.options.defaultLightTheme;
      var theme = this.container.options.themes.find(function (theme) {
        return theme.name === themeName;
      });

      if (theme && theme.default.auto) {
        this.container.loadTheme(themeName);
      }
    }
  }, {
    key: "handleClickMode",
    value: function handleClickMode(mode) {
      var container = this.container;
      var options = container.actualOptions;
      var pushNb = options.interactivity.modes.push.quantity;
      var removeNb = options.interactivity.modes.remove.quantity;

      switch (mode) {
        case Enums_1.ClickMode.push:
          {
            if (pushNb > 0) {
              var pushOptions = options.interactivity.modes.push;
              var group = (0, Utils_1.itemFromArray)([undefined].concat(_toConsumableArray(pushOptions.groups)));
              var groupOptions = group !== undefined ? container.actualOptions.particles.groups[group] : undefined;
              container.particles.push(pushNb, container.interactivity.mouse, groupOptions, group);
            }

            break;
          }

        case Enums_1.ClickMode.remove:
          container.particles.removeQuantity(removeNb);
          break;

        case Enums_1.ClickMode.bubble:
          container.bubble.clicking = true;
          break;

        case Enums_1.ClickMode.repulse:
          container.repulse.clicking = true;
          container.repulse.count = 0;
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = container.repulse.particles[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var particle = _step3.value;
              particle.velocity.setTo(particle.initialVelocity);
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }

          container.repulse.particles = [];
          container.repulse.finish = false;
          setTimeout(function () {
            if (!container.destroyed) {
              container.repulse.clicking = false;
            }
          }, options.interactivity.modes.repulse.duration * 1000);
          break;

        case Enums_1.ClickMode.attract:
          container.attract.clicking = true;
          container.attract.count = 0;
          var _iteratorNormalCompletion4 = true;
          var _didIteratorError4 = false;
          var _iteratorError4 = undefined;

          try {
            for (var _iterator4 = container.attract.particles[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
              var _particle = _step4.value;

              _particle.velocity.setTo(_particle.initialVelocity);
            }
          } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                _iterator4.return();
              }
            } finally {
              if (_didIteratorError4) {
                throw _iteratorError4;
              }
            }
          }

          container.attract.particles = [];
          container.attract.finish = false;
          setTimeout(function () {
            if (!container.destroyed) {
              container.attract.clicking = false;
            }
          }, options.interactivity.modes.attract.duration * 1000);
          break;

        case Enums_1.ClickMode.pause:
          if (container.getAnimationStatus()) {
            container.pause();
          } else {
            container.play();
          }

          break;
      }

      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = container.plugins[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var _step5$value = _slicedToArray(_step5.value, 2),
              plugin = _step5$value[1];

          if (plugin.handleClickMode) {
            plugin.handleClickMode(mode);
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }
    }
  }]);

  return EventListeners;
}();

exports.EventListeners = EventListeners;